
import { V1BEClient as V1BEClientClass } from "./v1-be";
import { AuthClient as AuthClientClass } from "./auth";
import { isLocalhost, isProd } from "@/lib/utils";
import { VERSION } from "@/constants/common";

export const services = {
	prod: {
		auth: "https://5wtkegceoi.execute-api.ap-southeast-1.amazonaws.com",
		v1BE: "https://4xqbo5tll9.execute-api.ap-southeast-1.amazonaws.com",
		baseUrl: "https://master.di2jxcjwflp03.amplifyapp.com",
	},
	dev: {
		auth: "https://5wtkegceoi.execute-api.ap-southeast-1.amazonaws.com",
		v1BE: "https://4xqbo5tll9.execute-api.ap-southeast-1.amazonaws.com",
		baseUrl: "https://master.di2jxcjwflp03.amplifyapp.com",
	},
	local: {
		auth: "http://localhost:8081",
		v1BE: "http://localhost:8082",
		baseUrl: "http://localhost:5174",
	},
};

const V1BEClient = new V1BEClientClass(
	isProd()
		? services.prod.v1BE
		: isLocalhost()
			? services.local.v1BE
			: services.dev.v1BE,
	VERSION
);
const authBaseURL = isProd()
	? services.prod.auth
	: isLocalhost()
		? services.local.auth
		: services.dev.auth;

const AuthClient = new AuthClientClass(authBaseURL, VERSION);

const setToken = (token: string) => {
	V1BEClient.setToken(token);
	AuthClient.setToken(token);
	localStorage.setItem("access_token", token);
};

const oidcConfig = {
	redirect_uri: isProd()
		? services.prod.baseUrl
		: isLocalhost()
			? services.local.baseUrl
			: services.dev.baseUrl,
	post_logout_redirect_uri: isProd()
		? services.prod.baseUrl
		: isLocalhost()
			? services.local.baseUrl
			: services.dev.baseUrl,
};

export { V1BEClient, AuthClient, setToken, oidcConfig };
